import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import credential from "../../API/Credentials.json";
import { apiRequest } from "../../API/apiServices";

export const googleMapDataKey = createAsyncThunk(
  "gmap/googleMapDataKey",
  async (_, { rejectWithValue }) => {
    try {
      const endpoint = credential?.SecretKey_API?.end_point;
      const apiMethod = credential?.request?.post;
      const apiBody = credential?.SecretKey_API?.body;
      const response = await apiRequest(apiMethod, endpoint, apiBody);
      if (response.error) {
        return rejectWithValue(response.error);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

const GoogleMapSlice = createSlice({
  name: "gmap",
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(googleMapDataKey.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(googleMapDataKey.fulfilled, (state) => {
        state.loading = false;
        state.error = false;
        state.success = true;
      })
      .addCase(googleMapDataKey.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export default GoogleMapSlice.reducer;
